import _ from 'lodash';
import Player from '@vimeo/player';

import SwooshableVideo from './swooshable-video';
import isUserSignedIn from '../is-user-signed-in';
import {
  recordVimeoPlayStartStatistic,
  recordVimeoPlayFinishedStatistic,
} from '../../services/statistics-service';

export default class SwooshableVimeoVideo extends SwooshableVideo {
  constructor(iframe) {
    super(iframe);

    const wireId = $(iframe).parents('article.wire').data().id;

    this.isPlaying = false;

    const player = new Player(iframe);

    player.on('play', () => {
      if (!isUserSignedIn() && !_.startsWith(window.location.pathname, '/wires/')) {
        player.unload();
        window.location = '/sign_up';
        return;
      }

      this.isPlaying = true;
      recordVimeoPlayStartStatistic(wireId);
    });

    player.on('pause', () => (this.isPlaying = false));

    player.on('ended', () => {
      this.isPlaying = false;
      recordVimeoPlayFinishedStatistic(wireId);
    });
  }

  get playing() {
    return this.isPlaying;
  }
}
